/* eslint-disable typebox-snake-case/typebox-object-keys-snake-case -- camelCase keys match existing DB/API schema */
import { Static, Type } from '@sinclair/typebox';

/**
 * `#rrggbb` strictement : le sélecteur (react-color `ChromePicker`, `c.hex`) n'émet que
 * cette forme, et le pipeline de rendu concatène un alpha hexadécimal (`${accent}12`)
 * ou recrache la valeur dans un attribut `style="…"` — une couleur libre y serait
 * soit du CSS invalide, soit une injection d'attribut dans tous les mails sortants.
 */
const HEX_COLOR_PATTERN = '^#[0-9a-fA-F]{6}$';

export const EmailColorsSchema = Type.Object({
  background: Type.String({ default: '#ffffff', pattern: HEX_COLOR_PATTERN }),
  accent: Type.String({ default: '#2563eb', pattern: HEX_COLOR_PATTERN }),
  text: Type.String({ default: '#18181b', pattern: HEX_COLOR_PATTERN }),
  cta: Type.String({ default: '#2563eb', pattern: HEX_COLOR_PATTERN }),
});
export type EmailColors = Static<typeof EmailColorsSchema>;

export const EmailTypographySchema = Type.Object({
  body: Type.String({ default: 'Arial' }),
});
export type EmailTypography = Static<typeof EmailTypographySchema>;

export const EmailBorderRadiusSchema = Type.Union([
  Type.Literal('none'),
  Type.Literal('soft'),
  Type.Literal('rounded'),
]);
export type EmailBorderRadius = Static<typeof EmailBorderRadiusSchema>;

export const EmailLayoutSchema = Type.Union([Type.Literal('newsletter'), Type.Literal('simple')]);
export type EmailLayout = Static<typeof EmailLayoutSchema>;

export const EmailStylesSchema = Type.Object({
  colors: EmailColorsSchema,
  typography: EmailTypographySchema,
  borderRadius: EmailBorderRadiusSchema,
  layout: EmailLayoutSchema,
  width: Type.Number({ default: 600 }),
});
export type EmailStyles = Static<typeof EmailStylesSchema>;
